/**
 * Модуль для инициализации и экспорта cadesplugin
 * Импортирует cadesplugin_api.js и экспортирует window.cadesplugin
 */
import './cadesplugin_api.js';

export const cadesplugin = window.cadesplugin;

